<template>
    <div>
      <baidu-map scroll-wheel-zoom class="map" ak="UmeYALQE9awE98LBNtNivQfr8hEoNP7W" :center="center" :zoom="zoom" @ready="handler">
        <bm-marker
                :position="{lng: 114.360219, lat: 22.708358}"
                :zoom="18"
                :icon="{url: require('../../../static/images/contact/定位.png'), size: {width: 32, height: 41}}"
        ></bm-marker>
        <bm-navigation v-if="flag" anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    </baidu-map>
    </div>
    </template>
    <script>
    import {
      BaiduMap,
      BmView,
      BmLocalSearch,
      BmNavigation,
      BmMarker
    } from 'vue-baidu-map'
    export default {
        components: {
        BaiduMap,
        BmView,
        BmLocalSearch,
        BmMarker,
        BmNavigation
      },
      data () {
        return {
          flag:false,
          center: {lng: 114.360219, lat: 22.708358},
          zoom: 3,
          resultList: [],
    
        }
      },
      created(){
        setTimeout(()=>{
          this.flag = true
        },1000)
    
      },
      methods: {
        handler ({BMap, map}) {
          // console.log(BMap, map)
          this.center.lng = 114.360219
          this.center.lat = 22.708358
          this.zoom = 15
        },
        
      }
    }
    </script>
    <style lang="less" scoped>
    .map {
        height: 340px;
      }
    </style>
    


// WEBPACK FOOTER //
// src/components/baiduMap/index.vue